import React, { memo } from 'react';
import FlexListComponent from './flexList';

const FlexList = (props) => {
  return <FlexListComponent {...props} />;
};

export default FlexList;
